import React, { useEffect, useState } from "react";
import { Alert, Spin } from "antd";
import { makeApiRequest } from "../../lib/api";
import { TypeParams } from "../../types";
import { useTranslation } from "react-i18next"; // Add this import

export interface ExtendedTypeParams extends TypeParams {
  preset_eu_id?: number;
  // preset_date_id?: number;
}

interface UnsubscribeProps {
  params: ExtendedTypeParams;
}

const EgwUnsubscribe: React.FC<UnsubscribeProps> = ({ params }) => {
  const { t } = useTranslation(); // Add this line
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch last ordered products and customer address
        const productsResponse = await makeApiRequest(params, "REACT_EU_UNSUBSCRIBE", { eu_id: params.preset_eu_id });
        const parsedProducts = JSON.parse(productsResponse);
        if (!parsedProducts || parsedProducts.STATUS !== "OK") {
          setError(t("kundenbereich.unsubscribe.error"));
          setLoading(false);
          return;
        }
        setLoading(false);
      } catch (error) {
        setError(t("kundenbereich.unsubscribe.error"));
        setLoading(false);
      }
    };

    fetchData();
  }, [params, t]);

  if (loading) {
    return (
      <div className="my-lg">
        <Spin />
      </div>
    );
  }

  //Error handling
  if (error) {
    return (
      <div>
        {/* <h1>Produktbestellung</h1> */}
        {t("kundenbereich.unsubscribe.title")}

        {error && (
          <>
            <Alert message={error} type="error" />
            <br />
            <br />
          </>
        )}
      </div>
    );
  }

  return (
    <div>
      {/* <h1>Produktbestellung</h1> */}
      {t("kundenbereich.unsubscribe.title")}
      <>
        <Alert message={t("kundenbereich.unsubscribe.success")} type="info" />
        <br />
        <br />
      </>
    </div>
  );
};

export default EgwUnsubscribe;
